import React, {useEffect, useState} from 'react';
import './style.css';
import SectionLayout from '../Layout/sectionLayout';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate, useSearchParams} from 'react-router-dom';
import jsVectorMap from 'jsvectormap';
import 'jsvectormap/dist/maps/world.js';
import 'jsvectormap/dist/css/jsvectormap.css';
import {setChapterById} from '../../../Store/Actions';
import {Col, Row} from 'antd';
import CommonWantToSeeAdsListing from '../CommonWantToSeeAdsListing';
import PbssSponsorsSidebar from '../PbssSponsorsSidebar';
import pinSvg from '../../../Assets/svgs/pin.svg';
import TabFilter from '../UserTabFilter';
import useLocalization from '../../../Localization';
import {LANGUAGES} from '../../../Localization/LanguageContext';
import {getPbssInternationalById} from '../../../Store/Actions/pbssInternational';

const PbssInMap = ({
  chaptersList,
  mapSize,
  specialAnnouncementHeading = false,
  pbssSponsors = [],
}) => {
  let dispatch = useDispatch();
  let navigate = useNavigate();
  const {ApplicationString, currentLanguage, changeLanguage} =
    useLocalization();
  const [searchParams, setSearchParams] = useSearchParams();

  const JobsAndAdsTabs = [
    {key: 'ads', label: ApplicationString['jobsAndAdsTabs.ads']},
    {
      key: 'jobs',
      label: ApplicationString['jobsAndAdsTabs.jobs'],
    },
  ];
  const [shouldRenderAdsJobs, setshouldRenderAdsJobs] = useState(false);
  const [mFont, setMfont] = useState('10px');
  const [tabKey, setTabKey] = useState('ads');
  const [shouldRender, setShouldRender] = useState(false);
  const pbssSponsorsContainerHeight =
    typeof mapSize === 'number' ? mapSize + 40 : mapSize;
  const {allPbssInternational} = useSelector(
    ({pbssInternational}) => pbssInternational,
  );
  const [globalSponsors, setGlobalSponsors] = useState([]);
  const handleWindowResize = () => {
    setshouldRenderAdsJobs(window.innerWidth > 1000);
  };
  useEffect(() => {
    window.addEventListener('resize', handleWindowResize);
    handleWindowResize();
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  useEffect(() => {
    if (
      allPbssInternational &&
      allPbssInternational?.data?.pbssInternational &&
      allPbssInternational?.data?.pbssInternational.length > 0
    ) {
      const first = allPbssInternational.data.pbssInternational[0];
      setGlobalSponsors(first?.pbss_sponsors_ids || []);
    }
  }, [allPbssInternational]);

  useEffect(() => {
    if (
      !allPbssInternational ||
      !allPbssInternational?.data ||
      !allPbssInternational?.data?.pbssInternational
    ) {
      dispatch(getPbssInternationalById());
    }
  }, [allPbssInternational, dispatch]);

  const handleChapterClick = (chapterId, chapterName) => {
    dispatch(setChapterById(chapterId));
    // Always navigate to English version of chapter pages
    navigate(`/chapter/${chapterName}`);
    if (currentLanguage === LANGUAGES.JA) {
      changeLanguage(LANGUAGES.EN);
      localStorage.setItem('pbssLanguage', LANGUAGES.EN);
      searchParams.delete('language');
    }
  };

  const calculateAndSetFontSize = (windowWidth) => {
    let calculatedFontSize;
    if (windowWidth >= 300 && windowWidth < 600) {
      calculatedFontSize = 11;
    } else if (windowWidth >= 600 && windowWidth < 768) {
      calculatedFontSize = 14;
    } else if (windowWidth >= 768 && windowWidth < 1440) {
      calculatedFontSize = 16;
    } else {
      calculatedFontSize = 16;
    }
    const integerFontSize = parseInt(10);
    return integerFontSize;
  };

  useEffect(() => {
    const handleWindowResize = () => {
      if (window.outerWidth > 469) {
        setShouldRender(true);
      } else {
        setShouldRender(false);
      }
    };
    window.addEventListener('resize', handleWindowResize);
    handleWindowResize();
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  useEffect(() => {
    let markers = [];
    if (chaptersList?.length > 0) {
      for (let chapter of chaptersList) {
        markers.push({
          name: chapter?.name,
          coords: [chapter.latitude, chapter.longitude],
          id: chapter?.id,
          normalized_name: chapter?.normalized_name,
        });
      }
      const map = new jsVectorMap({
        // world_merc, us_mill_en, us_merc_en,
        // us_lcc_en, us_aea_en, spain
        // russia, canada, iraq
        onLoaded: function (map) {
          window.addEventListener('resize', () => {
            map.updateSize();
            const dynamicFontSize = calculateAndSetFontSize(window.innerWidth);
            setMfont(dynamicFontSize + 'px');
          });
        },
        onMarkerClick: function (event, markerIndex) {
          document.querySelectorAll('.jvm-tooltip').forEach((element) => {
            element.parentNode.removeChild(element);
          });
          let chapterDetails = markers[markerIndex];
          if (chapterDetails) {
            handleChapterClick(
              chapterDetails.id,
              chapterDetails.normalized_name,
            );
          }
        },
        onRegionTooltipShow: function (event, tooltip, code) {
          tooltip.hide();
        },
        map: 'world',
        selector: '#map',
        backgroundColor: 'tranparent',
        draggable: false,
        zoomButtons: false,
        zoomOnScroll: false,
        zoomOnScrollSpeed: 3,
        zoomMax: 12,
        zoomMin: 1,
        zoomAnimate: false,
        zoomStep: 1.5,
        bindTouchEvents: false,
        // Line options
        lineStyle: {
          stroke: '#808080',
          strokeWidth: 1,
          strokeLinecap: 'round',
        },
        focusOn: {}, // focus on regions on page load
        /**
         * Markers options
         */
        markers: markers, // Set of markers to add to the map during initialization
        // labels: {
        //   markers: {
        //     render: function (chapter) {
        //       return chapter?.name;
        //     },
        //   },
        // },
        markersSelectable: true,
        markersSelectableOne: false,
        markerStyle: {
          initial: {
            r: 3,
            fill: '#374151',
            fillOpacity: 1,
            stroke: '#FFF',
            strokeWidth: 5,
            strokeOpacity: 0.5,
            image: pinSvg,
          },
          hover: {
            fill: '#2e56a4',
            cursor: 'pointer',
          },
          // selected: {
          //   fill: 'blue',
          // },
          // selectedHover: {},
        },
        markerLabelStyle: {
          initial: {
            fontFamily: "'Inter', sans-serif",
            fontSize: calculateAndSetFontSize(window.innerWidth) + 'px',
            fontWeight: 700,
            fill: '#000000',
          },
          // You can control the hover and selected state for labels as well.
          hover: {
            fill: '#2e56a4',
          },
          // selected: {
          //   fill: 'blue',
          // },
        },
        /**
         * Region styles
         */
        // labels: {
        //   // add a label for a specific region
        //   regions: {
        //     render(code) {
        //       return ['EG', 'KZ', 'CN'].indexOf(code) > -1
        //         ? 'Hello ' + code
        //         : '';
        //     },
        //   },
        // },
        //  regionsSelectable: true,
        // regionsSelectableOne: false,
        regionStyle: {
          // Region style
          initial: {
            // fill: 'rgb(190, 200, 227) !important',
            // fillOpacity: 1,
            // stroke: 'rgb(190, 200, 227) !important',
            // strokeWidth: 2px !important,
            // strokeOpacity: 1,
          },
          hover: {
            fillOpacity: 0.7,
            cursor: 'default',
          },
          // selected: {
          //   fill: '#000',
          // },
          // selectedHover: {},
        },
        // Tooltip configuration
        showTooltip: true,

        // Region label style
        // regionLabelStyle: {
        //   initial: {
        //     fontFamily: 'Verdana',
        //     fontSize: '12',
        //     fontWeight: 'bold',
        //     cursor: 'default',
        //     fill: '#35373e',
        //   },
        //   hover: {
        //     cursor: 'pointer',
        //   },
        // },
        // series: {
        //   markers: [
        //     // You can add one or more objects to create series for markers.
        //   ],
        //   regions: [
        //     // You can add one or more objects to create series for regions.
        //   ],
        // },
        // map visualization is used to analyze and display the geographically related data and present it in the form of maps.
        visualizeData: {
          scale: ['#eeeeee', '#999999'],
          // values: {
          //   EG: 29,
          //   US: 100,
          //   CA: 190,
          //   BR: 75,
          //   // ...
          // },
        },
      });
    }
  }, [chaptersList, shouldRender]);

  const defaultProps = {
    center: {lat: 59.95, lng: 30.33},
    zoom: 11,
  };

  const effectiveSponsors =
    pbssSponsors && pbssSponsors.length > 0 ? pbssSponsors : globalSponsors;

  const normalizedSponsors = Array.isArray(effectiveSponsors)
    ? effectiveSponsors
        .map((item) => (typeof item === 'string' ? {name: item} : item))
        .filter((item) => item && item?.name)
    : [];

  const hasSponsors = normalizedSponsors.length > 0;
  const mapLgSpan = hasSponsors ? 13 : 18;

  return (
    <React.Fragment>
      {shouldRenderAdsJobs && (
        <SectionLayout>
          <div className='align-right '>
            <div className='regin-head-container'>
              <label className='regin-label-text pbss-special-announcement'>
                {specialAnnouncementHeading && (
                  <>
                    {
                      ApplicationString[
                        'pbssInMapComponent.specialAnnouncementHeading'
                      ]
                    }{' '}
                    :{' '}
                    {specialAnnouncementHeading
                      ? specialAnnouncementHeading.includes('info@pbss.org')
                        ? specialAnnouncementHeading
                            .split('info@pbss.org')
                            .map((part, index, array) => (
                              <>
                                {part}
                                {index < array.length - 1 && (
                                  <a href='mailto:info@pbss.org'>
                                    info@pbss.org
                                  </a>
                                )}
                              </>
                            ))
                        : specialAnnouncementHeading
                      : ''}
                  </>
                )}
              </label>
            </div>
            <TabFilter setTabKey={setTabKey} tabs={JobsAndAdsTabs} />{' '}
          </div>
        </SectionLayout>
      )}
      <SectionLayout>
        <Row className='pbss-map-row-container row-gap-0' gutter={[16, 48]}>
          {!shouldRenderAdsJobs && (
            <Col span={24}>
              <label className='pbss-special-announcement'>
                {specialAnnouncementHeading && (
                  <>
                    {
                      ApplicationString[
                        'pbssInMapComponent.specialAnnouncementHeading'
                      ]
                    }{' '}
                    :{' '}
                    {specialAnnouncementHeading
                      ? specialAnnouncementHeading.includes('info@pbss.org')
                        ? specialAnnouncementHeading
                            .split('info@pbss.org')
                            .map((part, index, array) => (
                              <>
                                {part}
                                {index < array.length - 1 && (
                                  <a href='mailto:info@pbss.org'>
                                    info@pbss.org
                                  </a>
                                )}
                              </>
                            ))
                        : specialAnnouncementHeading
                      : ''}
                  </>
                )}
              </label>
            </Col>
          )}

          <Col span={24}>
            <Row
              gutter={{
                xs: 8,
                sm: 16,
                md: 24,
                lg: 32,
              }}>
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={mapLgSpan}
                className='map-container-column'>
                <div className='map-conatiner'>
                  <div className='d3-map'>
                    <div
                      style={{
                        width: '100%',
                        height: shouldRender ? mapSize : '250px',
                      }}
                      id='map'
                      className='map-js-container'></div>
                  </div>
                </div>
              </Col>
              {hasSponsors && (
                <Col xs={24} sm={24} md={24} lg={5}>
                  <PbssSponsorsSidebar
                    sponsors={normalizedSponsors}
                    containerHeight={pbssSponsorsContainerHeight}
                  />
                </Col>
              )}
              <Col className='col-ads-listing' xs={24} sm={24} md={24} lg={6}>
                <CommonWantToSeeAdsListing
                  tabKey={tabKey}
                  containerHeight={mapSize}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </SectionLayout>
    </React.Fragment>
  );
};
export default PbssInMap;
